import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumTaskStatus implements BaseEnumType {
  private static allValues: EnumTaskStatus[] = []; // make sure this is top-most
  
  public static open = new EnumTaskStatus(0, "Open", "enum_task_status_open");
  public static complete = new EnumTaskStatus(1, "Complete", "enum_task_status_complete");
  public static cancelled = new EnumTaskStatus(2, "Cancelled", "enum_task_status_cancelled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTaskStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOpen() { return this === EnumTaskStatus.open; }
  public isComplete() { return this === EnumTaskStatus.complete; }
  public isCancelled() { return this === EnumTaskStatus.cancelled; }

  public static getValues(): readonly EnumTaskStatus[] {
    return EnumTaskStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumTaskStatus[] {
    return EnumTaskStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTaskStatus {
    const found = EnumTaskStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTaskStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTaskStatus): EnumTaskStatus {
    const found = name ? EnumTaskStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTaskStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumTaskStatus>): boolean {
    return this.key === other?.key;
  }
}